module.exports = __webpack_public_path__ + "img/xiaozi_yida.7c6404e4.png";